import { countries } from "../countries";

/* eslint-disable react/prop-types */
export default function CountryField(props) {
  const { label, name, formik, placeholder, disabled = false } = props;

  return (
    <>
      <label
        htmlFor="email"
        className="block mb-2 text-sm font-medium text-white"
      >
        {label}
      </label>
      <select
        className="py-4 px-3 bg-[#E4E6E3] w-full border-none placeholder:text-info focus:text-info focus:border-none outline-none focus:outline-none focus:ring-0 font-imprim"
        name={name}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        placeholder={placeholder}
        disabled={disabled}
      >
        <option value="" disabled>
          Select Country
        </option>
        {countries.map((country) => (
          <option key={country.name} value={country.name}>
            {country.name}
          </option>
        ))}
        {/* Add more options as needed */}
      </select>
      {formik.touched[name] && formik.errors[name] && (
        <div className=" pt-3 text-[12px] text-red-600 font-imprima">
          {formik.errors[name]}
        </div>
      )}
    </>
  );
}
